import * as React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import { useIsMobile } from "../hooks/use-is-mobile";
import { MobileBottomSheet } from "./mobile/mobile-bottom-sheet";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MobileConfirmationSheet = ({
  open,
  handleClose,
  handleAction,
  isPerformingAction,
  dialogTitle,
  dialogContentText,
}) => (
  <MobileBottomSheet
    open={open}
    onClose={isPerformingAction ? () => { } : handleClose}
    footer={
      <Stack spacing={1}>
        <Button
          fullWidth
          size="large"
          variant="contained"
          disabled={isPerformingAction}
          onClick={handleAction}
          startIcon={isPerformingAction ? <CircularProgress size={18} color="inherit" /> : null}
        >
          Confirm
        </Button>
        <Button fullWidth size="large" disabled={isPerformingAction} onClick={handleClose}>
          Discard
        </Button>
      </Stack>
    }
  >
    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
      {dialogTitle}
    </Typography>
    <Typography variant="body1" color="text.secondary" id="confirmation-alert-dialog">
      {dialogContentText}
    </Typography>
  </MobileBottomSheet>
);

export const ConfirmationDialog = (props) => {
  const {
    open,
    handleClose,
    handleAction,
    isPerformingAction,
    dialogTitle,
    dialogContentText,
  } = props;
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileConfirmationSheet {...props} />;
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      aria-describedby="confirmation-alert-dialog"
    >
      {isPerformingAction && (
        <Box sx={{ p: 2 }}>
          <CircularProgress
            sx={{
              mx: "auto",
            }}
          />
        </Box>
      )}
      {!isPerformingAction && (
        <>
          <DialogTitle>{dialogTitle}</DialogTitle>
          <DialogContent>
            <DialogContentText
              id="confirmation-alert-dialog"
              color="text.primary"
            >
              {dialogContentText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Discard</Button>
            <Button onClick={handleAction}>Confirm</Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
